import React, { Suspense } from 'react';
import './CustomerPopup.css';

const WaiverForm = React.lazy(() => import('./WaiverForm'));
const StoreOrder = React.lazy(() => import('./StoreOrder'));

function CustomerPopup() {
  const params = new URLSearchParams(window.location.search);
  const mode = (params.get('mode') || 'store').toLowerCase();
  const isPopup = params.get('popup') === '1' || params.has('popup');

  const closeWindow = () => {
    try { window.close(); } catch (_) { /* ignore */ }
  };

  return (
    <div className={`customer-popup-shell ${isPopup ? 'popup-mode' : ''}`}>
      <header className="customer-header">
        <div className="brand">Braga BJJ — Customer</div>
        <div>
          <button className="btn" onClick={closeWindow}>Close</button>
        </div>
      </header>
      <main className="customer-main">
        <Suspense fallback={<div style={{padding:20}}>Loading…</div>}>
          {mode === 'waiver' ? (
            <WaiverForm onSave={() => { try { window.dispatchEvent(new CustomEvent('navigateTo', { detail: { view: 'waiver' } })); } catch(_){} }} />
          ) : (
            <StoreOrder onClose={() => { try { window.dispatchEvent(new CustomEvent('navigateTo', { detail: { view: 'store' } })); } catch(_){} }} />
          )}
        </Suspense>
      </main>
    </div>
  );
}

export default CustomerPopup;
